import styled from "styled-components";

export const Descricao = styled.p`
  font-size: 0.9rem;
  color: #4b5563;
  margin-bottom: 16px;
`;

export const CaixaCampos = styled.div`
  background-color: #f8f9fa;
  border-radius: 8px;
  padding: 16px;
`;

export const FooterBotoes = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
`;
